// Keenthemes' plugins
window.KTComponents = require('../../components/metronic/js/components/_init.js');
window.KTUtil = require('../../components/metronic/js/components/util.js');
window.KTApp = require('../../components/metronic/js/components/app.js');
window.KTEventHandler = require('../../components/metronic/js/components/event-handler.js');
window.KTBlockUI = require('../../components/metronic/js/components/blockui.js');
window.KTCookie = require('../../components/metronic/js/components/cookie.js');
window.KTDialer = require('../../components/metronic/js/components/dialer.js');
window.KTDrawer = require('../../components/metronic/js/components/drawer.js');
window.KTFeedback = require('../../components/metronic/js/components/feedback.js');
window.KTImageInput = require('../../components/metronic/js/components/image-input.js');
window.KTMenu = require('../../components/metronic/js/components/menu.js');
window.KTPasswordMeter = require('../../components/metronic/js/components/password-meter.js');
window.KTScroll = require('../../components/metronic/js/components/scroll.js');
window.KTScrolltop = require('../../components/metronic/js/components/scrolltop.js');
window.KTSearch = require('../../components/metronic/js/components/search.js');
window.KTStepper = require('../../components/metronic/js/components/stepper.js');
window.KTSticky = require('../../components/metronic/js/components/sticky.js');
window.KTSwapper = require('../../components/metronic/js/components/swapper.js');
window.KTToggle = require('../../components/metronic/js/components/toggle.js');

// Layout base js
window.KTAppSidebar = require('../../components/metronic/js/layout/sidebar.js');
window.KTLayoutSearch = require('../../components/metronic/js/layout/search.js');
window.KTLayoutToolbar = require('../../components/metronic/js/layout/toolbar.js');
window.KTThemeMode = require('../../components/metronic/js/layout/theme-mode.js');
window.KTThemeModeUser = require('../../components/metronic/js/layout/theme-mode-user.js');
